import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_ctx.localita && _ctx.previsione)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "min-w-1000px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "bg-grey-lighten-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col),
              _createVNode(_component_v_col, { class: "text-body-2 text-center bg-blue-lighten-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.esaSlot.night')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "text-body-2 text-center bg-blue-lighten-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.esaSlot.morning')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "text-body-2 text-center bg-blue-lighten-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.esaSlot.afternoon')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "text-body-2 text-center bg-blue-lighten-4" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.esaSlot.evening')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "bg-grey-lighten-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_container, { class: "w-66 pa-0 bg-grey-lighten-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { class: "text-body-1 font-weight-medium text-center bg-blue-lighten-4 pa-2" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t(`home.previsioni.dayByIndex.${ _ctx.getDayIndex(_ctx.previsione.data) }`)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_container, { class: "text-caption text-center pa-2 pb-0" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t( `home.previsioni.dayOfTheWeek.${ _ctx.getDayOfTheWeek(_ctx.previsione.data) }` )), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_container, { class: "text-h3 text-center font-weight-bold pa-2 pb-0" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getDay(_ctx.previsione.data)), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_container, { class: "text-subtitle-2 font-weight-medium text-center pa-2" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t( `home.previsioni.month.${ _ctx.getMonth(_ctx.previsione.data) }` )), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "mb-3",
                    height: "75px",
                    src: _ctx.getSimboloUrl(_ctx.previsione.previsione_esaoraria[0])
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_container, { class: "pa-0 text-h4 font-weight-bold text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].temperatura.gradi) + "°", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "mb-3",
                    height: "75px",
                    src: _ctx.getSimboloUrl(_ctx.previsione.previsione_esaoraria[1])
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_container, { class: "pa-0 text-h4 font-weight-bold text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].temperatura.gradi) + "°", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "mb-3",
                    height: "75px",
                    src: _ctx.getSimboloUrl(_ctx.previsione.previsione_esaoraria[2])
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_container, { class: "pa-0 text-h4 font-weight-bold text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].temperatura.gradi) + "°", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "mb-3",
                    height: "75px",
                    src: _ctx.getSimboloUrl(_ctx.previsione.previsione_esaoraria[3])
                  }, null, 8, ["src"]),
                  _createVNode(_component_v_container, { class: "pa-0 text-h4 font-weight-bold text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].temperatura.gradi) + "°", 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.localita.showData && _ctx.localita.showData.precipitazioni)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.precipitazioni')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getPrecipitazioneValue(_ctx.previsione.previsione_esaoraria[0])), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getPrecipitazioneValue(_ctx.previsione.previsione_esaoraria[1])), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getPrecipitazioneValue(_ctx.previsione.previsione_esaoraria[2])), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.getPrecipitazioneValue(_ctx.previsione.previsione_esaoraria[3])), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.precipitazioni)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 1,
                thickness: "1"
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.umidita)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 2,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.umidita')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].hr) + _toDisplayString(_ctx.$t('home.previsioni.units.umidita')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].hr) + _toDisplayString(_ctx.$t('home.previsioni.units.umidita')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].hr) + _toDisplayString(_ctx.$t('home.previsioni.units.umidita')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].hr) + _toDisplayString(_ctx.$t('home.previsioni.units.umidita')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.umidita)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 3,
                thickness: "1"
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.zero_termico)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 4,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.zeroTermico')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].zt), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].zt), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].zt), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].zt), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.zero_termico)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 5,
                thickness: "1"
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.quota_neve)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 6,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.quotaNeve')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].qn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].qn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].qn), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].qn), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.quota_neve)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 7,
                thickness: "1"
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.vento_medio)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 8,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.ventoMedio')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].vento.intensita) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')) + " " + _toDisplayString(_ctx.previsione.previsione_esaoraria[0].vento.direzione), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].vento.intensita) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')) + " " + _toDisplayString(_ctx.previsione.previsione_esaoraria[1].vento.direzione), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].vento.intensita) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')) + " " + _toDisplayString(_ctx.previsione.previsione_esaoraria[2].vento.direzione), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].vento.intensita) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')) + " " + _toDisplayString(_ctx.previsione.previsione_esaoraria[3].vento.direzione), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.vento_medio)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 9,
                thickness: "1"
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.raffica)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 10,
                class: "py-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('home.previsioni.rows.raffica')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[0].raffica) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[1].raffica) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[2].raffica) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { class: "text-body-2 text-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.previsione.previsione_esaoraria[3].raffica) + " " + _toDisplayString(_ctx.$t('home.previsioni.units.vento')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.localita.showData && _ctx.localita.showData.raffica)
            ? (_openBlock(), _createBlock(_component_v_divider, {
                key: 11,
                thickness: "1"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}